function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#EA7D24",
  d: "M32,55.963L32,55.963c2.2,0,4-1.8,4-4V12.037c0-2.2-1.8-4-4-4h0c-2.2,0-4,1.8-4,4v39.926 C28,54.163,29.8,55.963,32,55.963z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#EA7D24",
  d: "M49.593,29.63L49.593,29.63c1.556-1.556,1.556-4.101,0-5.657L34.824,9.204c-1.556-1.556-4.101-1.556-5.657,0 l0,0c-1.556,1.556-1.556,4.101,0,5.657L43.936,29.63C45.491,31.185,48.037,31.185,49.593,29.63z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#EA7D24",
  d: "M14.241,29.63L14.241,29.63c-1.556-1.556-1.556-4.101,0-5.657L29.01,9.204c1.556-1.556,4.101-1.556,5.657,0 l0,0c1.556,1.556,1.556,4.101,0,5.657L19.897,29.63C18.342,31.185,15.796,31.185,14.241,29.63z"
});

function SvgMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Medium",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    enableBackground: "new 0 0 64 64",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.7d0db347.svg";
export { ForwardRef as ReactComponent };